<template>
  <div class="programList">
    <div class="content">
      <van-collapse v-model="activeNames" accordion>
        <van-swipe-cell v-for="(item,index) in titelData" :key="index"
                        @touchstart.native.stop="gotouchstart(item,index)" @touchmove.native="gotouchmove"
                        @touchend.native="gotouchend">
          <van-cell icon="/static/images/etv-folder.png" :title="item.name"
                    is-link @click="goto(item)"></van-cell>
          <template slot="right">
            <van-button square type="danger" text="删除" @click="delGroup(item.id)"/>
          </template>
        </van-swipe-cell>
      </van-collapse>
    </div>

    <div class="btns">
      <div>
        <van-button color="#409eff" size="small" @click="reload">刷新</van-button>
        <span style="display: inline-block;width: 5px"></span>
        <van-button color="#409eff" size="small" @click="dialogShow=true">新建分组</van-button>
        <span style="display: inline-block;width: 5px"></span>
        <van-button color="#409eff" size="small" @click="createprogram">新建节目</van-button>
        <span style="display: inline-block;width: 5px"></span>
        <van-button color="#409eff" size="small" @click="allDeleteProgram">清空</van-button>
        <span style="display: inline-block;width: 5px"></span>
        <!--<router-link to="/h5Prorram"><van-button color="#409eff" size="small">H5</van-button></router-link>-->
      </div>
    </div>
    <nut-dialog title="新建节目分组" :visible="dialogShow" @ok-btn-click="onsubmit"
                :closeOnClickModal="false"
                :canDestroy="false"
                @close="inputDialogClose">
      <div>
        <nut-textinput
            v-model="groupName"
            label="名称："
            placeholder="请输入组名"
            :clearBtn="false"/>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import {Dialog, Notify, Toast} from 'vant'
import {mapActions} from 'vuex'
import $ from "jquery"

export default {
  name: 'programList',
  inject: ['reload'],
  data() {
    return {
      activeNames: '',
      data: [],
      titelData: [],
      dialogShow: false,
      groupName: '', //分组名称
      onlineState: '',
      programShow: false,
      value: '',
    }
  },
  mounted() {
    this.getData()
    this.$nextTick(() => {
      var winHeight = $(window).height()
      $(window).resize(function () {
        var thisWidth = $(this).height()
        if (winHeight > thisWidth) {
          $(".nut-tabbar").show()
        } else {
          $(".nut-tabbar").show()
        }
      })
    })

  },
  methods: {
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),

    gotouchstart(item, index) {
      if (item.id === "1") {
        return
      }

      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
      this.longClick = 0
      this.timeOutEvent = setTimeout(() => {
        this.longClick = 1
        Dialog.confirm({
          title: '删除节目分组',
          message: '确认删除该分组吗？',
        }).then(() => {
          this.$ajax.post('/etv/selectProCategoryProgramMouldNum.json', qs.stringify({
            id: item.id,
          })).then(res => {
            if (res.data.code === 0) {
              this.$ajax.post('/etv/deleteProCategory.json', qs.stringify({
                id: item.id,
              })).then(res => {
                if (res.data.code === 0) {
                  Toast('删除成功')
                  this.titelData.splice(index, 1)
                } else {
                  Toast(res.data.msg)
                }
              })
            } else {
              Toast(res.data.msg)
            }
          })
        }).catch(() => {
        })

      }, 700)//这里设置定时
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gotouchend() {
      clearTimeout(this.timeOutEvent)
      if (this.timeOutEvent !== 0 && this.longClick === 0) {
        return
      }
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gotouchmove() {
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
    },

    getData() {
      this.$ajax.post('/etv/selectPhoneProgramCategoryAlls.json').then(res => {
        this.titelData = res.data.data.pcList
      })
    },

    deleTer(clNo, index) {
      Dialog.confirm({
        title: '删除节目',
        message: '确认删除该节目？',
      }).then(() => {
        this.$ajax.post('/etv/deleteClientByClNo.json', qs.stringify({
          clNos: clNo,
        })).then(res => {
          if (res.data.code === 0) {
            Toast('删除成功')
            this.data.splice(index, 1)
          }
        })
      }).catch(() => {

      })
    },

    goto(data) {
      this.changeTopTitle('节目列表')
      this.setParentPage('programs')
      this.changeTopIconStatus(true)
      this.$router.push({path: '/programItem', query: {id: data.id, name: data.name}})
    },

    delGroup(id) {
      this.$ajax.post('/etv/selectProCategoryProgramMouldNum.json', qs.stringify({
        id,
      })).then(res => {
        if (res.data.code === 0) {
          this.$ajax.post('/etv/deleteProCategory.json', qs.stringify({
            id,
          })).then(res => {
            if (res.data.code === 0) {
              Notify({type: 'success', message: '删除成功'})
              this.reload()
            } else {
              Toast(res.data.msg)
            }
          })
        } else {
          Toast(res.data.msg)
        }
      })
    },

    inputDialogClose() {
      this.dialogShow = false
      this.programShow = false
      this.groupName = ''
      this.resolution = ''
    },

    onsubmit() {
      this.$ajax.post('/etv/insertProgramCategory.json', qs.stringify({
        name: this.groupName,
      })).then(res => {
        if (res.data.code === 0) {
          this.reload()
        } else {
          Toast(res.data.msg)
        }
      })
    },

    createprogram() {
      this.$router.push("/newprogram")
    },
    allDeleteProgram() {
      Dialog.confirm({
        title: '删除'
        , message: '是否确定删除所有空节目？',
      }).then(() => {
        this.$ajax.post('/etv/deleteNullProgramMould.json').then(res => {
          if (res.data.code === 0) {
            Toast('删除成功')
            this.getData()
          }
          Toast(res.data.msg)
        })
      }).catch(() => {
      })
    }
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.programList {
  .content {
    height: calc(100% - 110px);
    overflow-y: auto;

    .van-collapse-item__title--expanded {
      background: $uni-color-primary;
      color: #ffffff;

      .van-cell__right-icon {
        color: white;
      }
    }

    .van-collapse-item__content {
      padding: 0;
    }

    .item-child {
      list-style: none;
      padding: 0 16px;

      li {
        padding: 10px 0;
        line-height: 30px;
        position: relative;
        display: flex;
        justify-content: space-between;

        button {
          line-height: 22px;
        }

        img {
          height: 24px;
          margin-right: 10px;
        }

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: 1px solid $uni-border-bottom-color;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

      li:nth-last-child(1) {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: none;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

    }
  }

  .btns {
    display: flex;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
  }

  .a {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .popup-title {
    height: 30px;
    line-height: 30px;
    background: #f1f1f1;
    padding-left: 15px;
  }

  .popup-btns {
    margin-top: 15px;
    padding: 0 15px;
  }

  .button-btns {
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .van-cell__title {
    line-height: 30px !important;
    font-size: 16px;

    .van-cell__right-icon {
      line-height: 30px;
    }
  }
  .van-cell__left-icon {
    line-height: 30px;
  }
  .van-button--mini{
    line-height: 30px;
  }
}
</style>
